import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import icons from "../../lib/icons";
import MemorizedIbans from "../withdraws/MemorizedIbans";
import MemorizedIbansList from "./MemorizedIbansList";

const numberReg = /^[0-9]*$/;

const WithdrawIbanInput = ({
  control,
  name,
  value = "",
  errors,
  className,
  setValue,
  clearErrors,
  label,
  placeholder,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleClickContainer = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
    if (value.length < 2) {
      document.querySelector(`input[name=field-1]`)?.focus();
    }
  };
  useEffect(() => {
    if (value.length === 24) setIsDropdownOpen(false);
  }, [value]);

 

  return (
    <div>
      <div className="flex gap-2 font-semibold text-[14px]  items-center">
        {label} {errors && <div className="error-text">{errors?.message}</div>}
      </div>
      <div className="relative">
        <div
          className={`flex items-center h-[52px] px-2 outline-none rounded-v-md  border-[1px] border-[#ccc]  gap-2 cursor-text ${className}`}
          onClick={(e) => handleClickContainer(e)}
        >
          <WithdrawIbanHeader value={value} errors={errors} />
        </div>

        <div
          className={` dropdown ${
            isDropdownOpen
              ? "max-h-[350px] flex flex-col gap-4"
              : "max-h-[0px] overflow-hidden opacity-0  "
          }`}
        >
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value } }) => (
              <IbanInputFields
                isSheba={true}
                value={value}
                onChange={onChange}
              />
            )}
          />
          <MemorizedIbansList
            setValue={setValue}
            clearErrors={clearErrors}
            setIsDropdownOpen={setIsDropdownOpen}
          />
          <MemorizedIbans setValue={setValue} clearErrors={clearErrors} />
        </div>
      </div>
    </div>
  );
};

export default WithdrawIbanInput;

const IbanInputFields = ({ isSheba, value, onChange }) => {
  const inputConfig = isSheba ? [2, 4, 4, 4, 4, 4, 2] : [4, 4, 4, 4];

  const splitValue = [];
  let currentIndex = 0;
  inputConfig.forEach((len) => {
    splitValue.push(value.slice(currentIndex, currentIndex + len));
    currentIndex += len;
  });

  const handleInputChange = (e, index, length) => {
    const inputs = document.querySelectorAll(`[name^="field-"]`);
    let newValue = Array.from(inputs)
      .map((i) => i.value)
      .join("");

    if (e.target.value.length <= 24 && numberReg.test(e.target.value)) {
      onChange(newValue);
    }

    // Auto-focus next input
    if (e.target.value.length > length && e.target.value.length !== 16) {
      const next = document.querySelector(`input[name=field-${index + 1}]`);
      if (next) next.focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key !== "Backspace") return;

    if (e.target.value.length === 0) {
      const prev = document.querySelector(`input[name=field-${index - 1}]`);
      if (prev) prev.focus();
    }

    if (index === 5 && e.target.value.length === 3) {
      const prev = document.querySelector(`input[name=field-4]`);
      if (prev) prev.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    let paste = e.clipboardData.getData("text").replace(/\s/g, "");

    if (isSheba && paste.startsWith("IR")) paste = paste.slice(2);
    onChange(paste);

    const inputs = document.querySelectorAll(`[name^="field-"]`);
    let remain = paste;

    inputs.forEach((input) => {
      const len = parseInt(input.getAttribute("data-length"), 10);
      input.value = remain.slice(0, len);
      remain = remain.slice(len);
    });
  };

  useEffect(() => {
    const first = document.querySelector(`input[name=field-1]`);
    if (isSheba && first) {
      first.focus();
      const len = first.value.length;
      first.setSelectionRange(len, len);
    }
  }, [isSheba]);

  useEffect(() => {
    const input5 = document.querySelector(`input[name=field-5]`);
    if (value.length === 17 && input5) {
      input5.focus();
      const len = input5.value.length;
      input5.setSelectionRange(len, len);
    }
  }, [value]);

  return (
    <div
      className="h-[52px] px-2 outline-none rounded-v-md  border-[1px] border-[#ccc] flex gap-2 items-center   "
      dir="ltr"
    >
      {isSheba && <img src={icons.iban} alt="iban" className="size-6" />}
      <div className="flex gap-1">
        {inputConfig.map((length, index) => (
          <input
            key={index}
            name={`field-${index + 1}`}
            data-length={length}
            inputMode="numeric"
            className="text-[14px] md:text-[16px] border-b border-[#d8d0d0] outline-none h-fit w-fit"
            style={{ flex: length, width: length * 11 }}
            value={splitValue[index] || ""}
            maxLength={index === 6 ? length : null}
            onChange={(e) => handleInputChange(e, index + 1, length)}
            onKeyDown={(e) => handleBackspace(e, index + 1)}
            onPaste={handlePaste}
          />
        ))}
      </div>
    </div>
  );
};

const WithdrawIbanHeader = ({ errors, value }) => (
  <>
    {value ? (
      <div className="flex justify-end gap-1 items-center w-full cursor-pointer">
        <p> {value}</p>
        <img src={icons.iban} className="size-6 " alt="arrow" />
      </div>
    ) : (
      <div className="flex justify-between items-center w-full cursor-pointer">
        <button tabIndex={-1} className=" text-[12px] text-neutral-400 ">
          کد شبای ۲۴ رقمی
        </button>
        <img src={icons.arrow} className="size-6 " alt="arrow" />
      </div>
    )}
  </>
);
